<template>
  <div v-if="issuePayment" class="issuePayment">
    <FormKit
      id="issuePayment-form"
      v-model="issuePaymentFormData"
      type="form"
      :actions="false"
    >
      <FormKit type="group" name="paymentInfo">
        <Input
          class="input-reference"
          name="reference"
          :value="issuePaymentFormData.paymentInfo.reference"
          type="text"
          :label="$t('reference')"
        />
        <Input
          :class="{
            'input-totalSum': !totalSumIncorrect,
            'input-totalSum-incorrect': totalSumIncorrect
          }"
          name="totalSum"
          :value="issuePaymentFormData.paymentInfo.totalSum"
          type="number"
          :label="$t('totalSum')"
          min="0.01"
          :validation="[['required'], ['min:0.01']]"
          :validation-messages="{
            required: $t('validation.required'),
            min: $t('minimal_payment_amount')
          }"
        />
        <span v-if="totalSumIncorrect" class="totalSum-error">
          {{ $t('minimal_payment_amount') }}
        </span>
        <div class="comment">
          <label class="label-comment" for="comment">
            {{ $t('customerReceiptMessage') }}
          </label>
          <textarea
            id="comment"
            v-model="issuePaymentFormData.paymentInfo.comment"
            class="input-comment"
            maxlength="250"
          >
          </textarea>
        </div>
      </FormKit>
    </FormKit>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'IssuePayment',
  props: ['issuePayment'],
  data() {
    return {
      issuePaymentFormData: {
        paymentInfo: {
          reference: '',
          totalSum: 0.01,
          comment: ''
        }
      },
      openButton: false,
      totalSumIncorrect: false
    };
  },
  methods: {
    emitFormData() {
      this.$emit('update:issue-payment-form-data', this.issuePaymentFormData);
    }
  },
  watch: {
    issuePaymentFormData() {
      this.emitFormData();

      if (+this.issuePaymentFormData.paymentInfo.totalSum < 0.01) {
        this.totalSumIncorrect = true;
      } else {
        this.totalSumIncorrect = false;
      }
    }
  }
})
export default class IssuePayment extends Vue {}
</script>

<style lang="scss">
.issuePayment {
  margin-left: 26px;
  #issuePayment-form {
    .input-reference {
      margin-top: 38px;
    }
    .input-totalSum-incorrect {
      border: 1px solid $red;
      border-radius: 8px;
      margin-bottom: 0;
      .formkit-outer {
        border-radius: 8px;
        .formkit-wrapper {
          border-radius: 8px;
          .formkit-inner {
            .formkit-input {
              border: none;
            }
          }
        }
      }
    }
    .totalSum-error {
      display: block;
      color: $red;
      font-size: $fourteenSize;
      margin-top: 10px;
      margin-bottom: 30px;
    }
    .comment {
      position: relative;
      label {
        position: absolute;
        font-family: 'Ubuntu-Regular';
        top: -6px;
        left: 15px;
        padding: 0 5px;
        background: $white;
        color: $label;
        font-weight: 400;
        font-size: $twelveSize;
        line-height: $fourteenSize;
        z-index: 1;
      }
      textarea {
        width: 445px;
        height: 132px;
        padding: 16px;
        font-size: $fourteenSize;
        border: 1px solid $border;
        border-radius: 8px;
        resize: none;
        &:focus {
          outline: none;
        }
      }
    }
  }
}
</style>
